<!--
  App.vue — the <v-app> shell.
  Purpose: the Vuetify application root. When a session exists it renders the dark left
  NavRail + a full-bleed content area (so the monitoring screen's map fills the viewport,
  matching go.lacak.io). Public routes (login) render the content area alone. Login state
  is read from the `session_key` cookie and re-evaluated on every navigation.
  Reconstructed from lacak.io deployed behavior; app-specific contract verbatim
  (session cookie, `user/*` getters/actions — AUTH-SESSION), internal impl re-authored.
-->
<template>
  <v-app>
    <div class="app-shell">
      <nav-rail v-if="loggedIn"></nav-rail>
      <main class="app-content">
        <router-view></router-view>
      </main>
    </div>
  </v-app>
</template>

<script>
import { hasSession } from '@/shell/session'
import NavRail from '@/shell/NavRail.vue'

export default {
  name: 'App',
  components: { NavRail },
  data() {
    return { loggedIn: hasSession() }
  },
  watch: {
    // Cookie reads are not reactive; re-evaluate login state on every navigation.
    $route() {
      this.loggedIn = hasSession()
    }
  }
}
</script>

<style>
.app-shell {
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;
}
.app-content {
  flex: 1;
  height: 100%;
  position: relative;
  overflow: auto;
}
/* The monitoring screen owns the full content area with no padding. */
.app-content > .online-screen {
  height: 100%;
}
</style>
